import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

interface ErrorPageProps {
    errorMessage?: string;
    containerClassname?: string;
    showGoBackButton?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ errorMessage, containerClassname, showGoBackButton = true }) => {
    const navigate = useNavigate();

    return (
        <div className={`error_container ${containerClassname ? containerClassname : ''}`}>
            <div className="error_area">
                <img src="/assets/images/error/error.svg" alt={errorMessage} />
                <h3>Error</h3>
                <h6>{errorMessage}</h6>

                {showGoBackButton && (
                    <Button
                        label="Go back"
                        icon="bi bi-arrow-left"
                        className="gp_back_btn"
                        onClick={() => navigate(-1)}
                    />
                )}
            </div>
        </div>
    )
}

export default ErrorPage;